// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickViewModalStyles } from "@bg/App/Components/QuickViewModal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickViewModalStyles.titleText = {
    typographyProps: {
        variant: "h1",
        forwardAs: "span",
        css: css`
            color: ${getColor("common.ui1")} !important;
        `,
    },
    css: css`
        color: ${getColor("common.ui1")} !important;
        width: fit-content;
    `,
};

quickViewModalStyles.qtyOrdredWrapper = {
    css: css`
        max-width: 130px;
    `,
};

quickViewModalStyles.viewFulDetailsLink = {
    color: "primary",
    icon: {
        iconProps: {
            src: "ArrowRight",
            size: 14,
            color: "tertiary",
        },
        position: "right",
    },
};
